import type { IErrorResponse, ProductFavorite } from '@/types';

import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useDeleteFavorites = (): UseMutationResult<
  [],
  IErrorResponse,
  { id: string }
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: ({ id }: { id: string }) => api.delete(urls.deleteFavorite(id)),
    onSuccess: (_, { id }) => {
      queryClient.setQueryData<ProductFavorite[]>(
        [urls.productFavorites],
        (oldData) => {
          return oldData ? oldData.filter((item) => item.id !== id) : [];
        }
      );
      standaloneToast({
        status: 'success',
        title: t('deleteFromLike'),
      });
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: [urls.productFavorites] });
    },
  });
};

export default useDeleteFavorites;
